export default class ChangeLog {
  constructor(api) {
    this.api = api;
  }

  getByObjectUUID(objectUUID, layer, onSuccess, onError) {
    return this.api.http_fibercloud
      .get(
        "v1/logs/activities?filter[layers]=" +
          layer +
          "&filter[object_uuid]=" +
          objectUUID +
          "&append=causer_user"
      )
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }
}



// WEBPACK FOOTER //
// ./src/api/changeLog.js